import React from "react";
import Typography from "@material-ui/core/Typography";
import { RouteComponentProps } from "react-router";
import { ApplicationState } from "../../store";
import * as APIStore from "../../store/APIStore";
import { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button, IconButton, Box } from "@material-ui/core";
import moment from 'moment';
import RequestAccessToken from '../../util/authService';
import { Link, useHistory } from "react-router-dom";
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

export interface PatientMedicalRecordsIndexProps {
    patientMedicalRecords: APIStore.PatientMedicalRecord[],
}

const formatDate = (date: string, dateOnly: boolean) => {
    if (!date) {
        return null;
    }
    if (dateOnly) {
        return moment(date).format("MM-DD-YYYY");
    }
    return moment(date).format("hh:mm:ss A MM-DD-YYYY");
}



const PatientMedicalRecordsIndex = (props: PatientMedicalRecordsIndexProps) => {
    let { patientMedicalRecords } = props;

    if (!patientMedicalRecords?.length) {
        return (<>
            <Typography variant="body1" component="div" gutterBottom>
                <strong>Medical Records:</strong> None
            </Typography>

        </>);
    }

    const history = useHistory();


    const documentItemClick = (
        medicalRecord: APIStore.PatientMedicalRecord
    ) => {
        let ptId = medicalRecord.ptId;
        let name = medicalRecord.condensedName;
        history.push(`/record/document/${ptId}/${name}`);
    };

    return (
        <>
            <Typography variant="body1" component="div" gutterBottom>
                <strong>Medical Records:</strong>
            </Typography>
            <TableContainer>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Record Name</TableCell>
                            <TableCell align="right">Type</TableCell>
                            <TableCell>Date</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {patientMedicalRecords.map((val: APIStore.PatientMedicalRecord) => (

                            <>
                                <TableRow>
                                    <TableCell align="left">
                                        <IconButton onClick={() => documentItemClick(val)} color="primary" aria-label="View whole note">
                                            <OpenInNewIcon />
                                        </IconButton>
                                        {
                                            val.recordName
                                        }

                                    </TableCell>
                                    <TableCell align="right">

                                        {
                                            val.recordType
                                        }

                                    </TableCell>

                                    <TableCell align="right">

                                        {formatDate(val.createdDate, true)}

                                    </TableCell>

                                </TableRow>
                                <TableRow>
                                    <TableCell scope="row">

                                        <Typography component="p">
                                            Record Summary
                                        </Typography>

                                    </TableCell>
                                </TableRow>
                                <TableRow>

                                    <TableCell colSpan={2}  >
                                        <Typography component="p">
                                            {val.summary}
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            </>

                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
}


export default connect(
    (state: ApplicationState) => state.vitalsContext,
    APIStore.actionCreators
)(PatientMedicalRecordsIndex as any);
